<div class="xc" [ngClass]="seed?.lifecycleCss">
  <span class="xc-strip"></span>
  <app-issue-detail [issueId]="issueId"
                    [assetId]="assetId"
                    [assetGroups]="assetGroups"
                    [seed]="seed"
                    [issueCasesGate]="true"
                    layout="drawer"
                    [showHeader]="true"
                    [closeAsCollapse]="true"
                    [startOpen]="true"
                    [canMaintain]="canMaintain"
                    (closeRequested)="collapse.emit()"></app-issue-detail>
</div>